import { StringHelper } from './StringHelper';
import { locale } from 'moment';

export class LocalStorageHelper {

    public static SetItemForMetohd(data: any, key: string) {
        
        // create new item in local storage
        localStorage.setItem(key, data);
    }

    public static GetItemForMethod(key: string) {

        // get item by key
        return localStorage.getItem(key);
    }

    public static ContainsKeyForMethod(key: string) {

        // check id local storage contains item with key
        return !StringHelper.IsNullOrEmptyOrUndefined(localStorage.getItem(key));
    }

    public static KeyForMetohd(tokenName: string, methodName: string, paramsHash: string) { 

        // create and return key
        return tokenName + '_M_' + methodName + '_' + (StringHelper.IsNullOrEmptyOrUndefined(paramsHash) ? 'NO_PARAM_HASH' : paramsHash);
    }

    public static ClearStartsWith(prefix: string) {

        // each all localStorage items
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).indexOf(prefix) >= 0) {
                localStorage.removeItem(localStorage.key(i));
            }
        }
    }
}